$(() => {
    var dilemmaContainerBlocks = document.querySelectorAll('.dilemmaContainer--container');

    if (!dilemmaContainerBlocks || !dilemmaContainerBlocks.length) return;

    function getDilemmaState(containerElement) {
        let dilemmaStepElements = containerElement.querySelectorAll('[data-dilemmaContainer-step]');
        let currentStepElement = containerElement.querySelector(
            '[data-dilemmaContainer-step]:not(.d-none)'
        );

        return {
            dilemmaStepElements,
            currentStepElement,
            currentStepIndex: Array.from(dilemmaStepElements).indexOf(currentStepElement)
        };
    }

    function goToNextStep(
        dilemmaContainerBlock,
        previousButton,
        nextButton,
        footerControlsElement
    ) {
        let dilemmaState = getDilemmaState(dilemmaContainerBlock);

        if (dilemmaState.currentStepIndex === dilemmaState.dilemmaStepElements.length - 1) return;

        dilemmaState.currentStepElement.classList.add('d-none');
        dilemmaState.dilemmaStepElements[dilemmaState.currentStepIndex + 1].classList.remove(
            'd-none'
        );

        // Hide next button if we are at the last step
        if (dilemmaState.currentStepIndex === dilemmaState.dilemmaStepElements.length - 2) {
            nextButton.classList.add('d-none');
        }

        // Show previous button if it was hidden
        if (dilemmaState.currentStepIndex === 0) {
            previousButton.classList.remove('d-none');
        }

        let footerElement = dilemmaState.currentStepElement.querySelector(
            '.dilemmaContainer--footer'
        );

        if (!footerControlsElement || !footerElement) return;

        footerControlsElement.classList.add('d-none');
        footerElement.classList.add('d-none');
    }

    function scrollToContainer(containerElement) {
        const y = containerElement.getBoundingClientRect().top + window.scrollY - 100;

        // Scroll to top of the container
        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }

    dilemmaContainerBlocks.forEach((dilemmaContainerBlock) => {
        let previousButton = dilemmaContainerBlock.querySelector(
            'button[data-dilemmaContainer-previous]'
        );
        let nextButton = dilemmaContainerBlock.querySelector('button[data-dilemmaContainer-next]');

        let footerNextButton = dilemmaContainerBlock.querySelector(
            'button[data-dilemmaContainer-footer-next]'
        );

        let footerControlsElement = dilemmaContainerBlock.querySelector(
            '.dilemmaContainer--footer-controls'
        );

        if (!previousButton || !nextButton || !footerNextButton) return;

        previousButton.addEventListener('click', () => {
            let dilemmaState = getDilemmaState(dilemmaContainerBlock);

            if (dilemmaState.currentStepIndex === 0) return;

            dilemmaState.currentStepElement.classList.add('d-none');
            dilemmaState.dilemmaStepElements[dilemmaState.currentStepIndex - 1].classList.remove(
                'd-none'
            );

            // Hide previous button if we are at the first step
            if (dilemmaState.currentStepIndex === 1) {
                previousButton.classList.add('d-none');
            }

            // Show next button if it was hidden
            if (dilemmaState.currentStepIndex === dilemmaState.dilemmaStepElements.length - 1) {
                nextButton.classList.remove('d-none');
            }

            let footerElement = dilemmaState.currentStepElement.querySelector(
                '.dilemmaContainer--footer'
            );

            if (!footerControlsElement || !footerElement) return;

            footerControlsElement.classList.add('d-none');
            footerElement.classList.add('d-none');

            scrollToContainer(dilemmaContainerBlock);
        });

        nextButton.addEventListener('click', () => {
            goToNextStep(dilemmaContainerBlock, previousButton, nextButton, footerControlsElement);

            scrollToContainer(dilemmaContainerBlock);
        });

        footerNextButton.addEventListener('click', () => {
            goToNextStep(dilemmaContainerBlock, previousButton, nextButton, footerControlsElement);

            scrollToContainer(dilemmaContainerBlock);
        });

        // Show footer controls if we are not at the last step and has answered

        let dilemmaOptionsButtons = dilemmaContainerBlock.querySelectorAll(
            '.dilemmaBlock--optionBtn'
        );

        dilemmaOptionsButtons.forEach((optionButton) => {
            optionButton.addEventListener('click', () => {
                let dilemmaState = getDilemmaState(dilemmaContainerBlock);

                if (dilemmaState.currentStepIndex === dilemmaState.dilemmaStepElements.length - 1)
                    return;

                let footerElement = getDilemmaState(
                    dilemmaContainerBlock
                ).currentStepElement.querySelector('.dilemmaContainer--footer');

                let footerControlsElement = footerNextButton.closest(
                    '.dilemmaContainer--footer-controls'
                );

                if (!footerControlsElement || !footerControlsElement.classList.contains('d-none'))
                    return;

                footerElement.classList.remove('d-none');
                footerControlsElement.classList.remove('d-none');
            });
        });
    });
});
